import { Router, UrlTree } from '@angular/router';
import {
  ApplicationSelectionType,
  ApplicationSort,
  ApplicationTypes,
  AssetFinanceProductType,
  KybAttentionReason,
  KybQueueView,
  StageNameType,
  UserType
} from '@portal-workspace/grow-shared-library';

export const navigationUrlForLgRebateCalculator = () => {
  return  ['/s', 'lg-rebate-calculator'];
}

export const navigationUrlForAssetFinanceCalculator = () => {
  return  ['/s', 'asset-finance-calculator'];
}

export const navigationUrlForBusinessLoansCalculator = () => {
  return   ['/s', 'business-loans-calculator'];
}

export const navigationUrlForOverdraftCalculator = () => {
  return ['/s', 'business-overdraft-calculator'];
}

export type QueryParams = {
  reload?: boolean,
  limit?: number,
  offset?: number,
  search?: string,
  filterOpportunityOwner?: string[],
  filterCreditOfficer?: string[],
  filterSettlementOfficer?: string[],
  applicationType?: ApplicationTypes[],
  applicationStage?: StageNameType[],
  sorts?: ApplicationSort,
  statistic?: string
} 

export const navigationUrlForAssetFinance = (
  router: Router,
  selectedAssetProductType: AssetFinanceProductType,
  isSwitchToEasyDoc: boolean,
  applicationId?: number,
  queryParams?: QueryParams,
): UrlTree => {
  const url = applicationId ? ['/s', 'asset-finance', applicationId] : ['/s', 'asset-finance'];
  const qp = {
    ...(queryParams ?? {}),
    productType: selectedAssetProductType,
    isSwitchToEasyDoc,
  };
  return router.createUrlTree(url, {queryParams: qp});
}

export const navigationUrlForAssetProductSelector = (applicationId?: number) => {
  return (applicationId ? ['/s', 'asset-finance-product-selector', applicationId] : ['/s', 'asset-finance-product-selector']);
}

export const navigationUrlForAssetProductSelectorWithQueryParams = (
  router: Router,
  applicationId?: number,
  queryParams?: QueryParams
) => {
  return router.createUrlTree(applicationId ? ['/s', 'asset-finance-product-selector', applicationId] : ['/s', 'asset-finance-product-selector'], {queryParams});
}

export const navigationUrlForBusinessFinance = (applicationId?: number)  => {
  return   (applicationId ? ['/s', 'business-term-loan', applicationId] : ['/s', 'business-term-loan']);
}

export const navigationUrlForBusinessFinanceWithQueryParams = (
  router: Router,
  applicationId?: number,
  queryParams?: QueryParams
) => {
  return router.createUrlTree(applicationId ? ['/s', 'business-term-loan', applicationId] : ['/s', 'business-term-loan'], {queryParams});
}

export const navigationUrlForBusinessOverdraft = (applicationId?: number)  => {
  return ( applicationId ? ['/s', 'business-overdraft', applicationId] : ['/s', 'business-overdraft']);
}

export const navigationUrlForBusinessOverdraftWithQueryParams = (
  router: Router,
  applicationId?: number,
  queryParams?: QueryParams
) => {
  return router.createUrlTree(applicationId ? ['/s', 'business-overdraft', applicationId] : ['/s', 'business-overdraft'], {queryParams});
}

export const navigationUrlForInsurancePremium = (applicationId?: number)  => {
  return ( applicationId ? ['/s', 'insurance-premium', applicationId] : ['/s', 'insurance-premium']);
}

export const navigationUrlForInsurancePremiumWithQueryParams = (
  router: Router,
  applicationId?: number,
  queryParams?: QueryParams
) => {
  return router.createUrlTree( applicationId ? ['/s', 'insurance-premium', applicationId] : ['/s', 'insurance-premium'], {queryParams});
}

export const navigationUrlForApplicationCreditTab = (applicationId: number) => {
  return ['/s', 'application', applicationId, 'credit']
}

export const navigationUrlForNotificationsManagement = ()  => {
  return ( ['/s', 'notifications-management']);
}

export const navigationUrlForAuditLogs = () => {
  return ( ['/s', 'audit-logs']);
}

export const navigationUrlForRateCardDetails = (rateCardId: number,queryParams?: { [key: string]: string | string[] | undefined })  => {
  return ( ['/s', 'rate-card', rateCardId]);
}

export const navigationUrlForAddRatecard = () => {
  return ( ['/s', 'rate-card']);
}

export const navigationUrlForApplication = (
  applicationId: string,
  innerTabs: ApplicationSelectionType = 'app',
  innerTabParam: string | undefined = undefined,
  queryParams?: QueryParams
)  => {
  if (innerTabParam == undefined) {
    return  (['/s', 'application', applicationId , innerTabs]);
  } else {
    return  (['/s', 'application', applicationId , innerTabs, innerTabParam]);
  }
}

export const navigationUrlForApplicationWithQueryParams = (
  router: Router,
  applicationId: string,
  innerTabs: ApplicationSelectionType = 'app',
  queryParams?: QueryParams
) => {
  return router.createUrlTree(['/s', 'application', applicationId, innerTabs], {queryParams});
}

export const navigationUrlForApplications = (
)  => {
  return  (['/s', 'applications']);
}

export const navigationUrlForApplicationsWithQueryParams = (
  router: Router,
  queryParams?: QueryParams
) => {
  return  router.createUrlTree(['/s', 'applications'],{queryParams});
}

export const navigationUrlForAllApplication= ()  => {
  return ( ['/s', 'all-applications']);
}

export const navigationUrlForCustomers = ()  => {
  return  (['/s', 'customers']);
}

export const navigationUrlForCustomerDetails = (customerId: number) => {
  return ( ['/s', 'customer', customerId]);
}

export const navigationUrlForPismoDisplayTransactions = (customerId: number, accountId: number)  => {
  return ( ['/s', 'customer', customerId, accountId]);
}

export const navigationUrlForPismoStatementDetails = (userId: number, accountId: number, statementId: number)  => {
  return ( ['/s', 'pismo-statement-details', userId, accountId, statementId]);
}

export const navigationUrlForUnsingedInvoices = () => {
  return ( ['/s', 'unsigned-invoices']);
}

export const navigationUrlForManualPayment = ()  => {
  return ( ['/s', 'manual-payment']);
}

export const navigationUrlForUsers = ()  => {
  return ( ['/s', 'users']);
}

export const navigationUrlForUserDetail = (userId: number, type: UserType = 'broker-user')  => {
  return ( type === 'customer-user' ? ['/s', 'user', userId, 'customer-user'] : ['/s', 'user', userId, 'broker-user']);
}

export const navigationUrlForPendingApprovals = ()  => {
  return ( ['/s', 'pending-approvals']);
}

export const navigationUrlForEditCreditFlow = (flowId: number) => {
  return ( ['/s', 'edit-credit-flow', flowId]);
}

export const navigationUrlForPromotion = ()  => {
  return ( ['/s', 'promotion']);
}

export const navigationUrlForPendingApprovalUserDetail = (userId: number)  => {
  return ( ['/s', 'pending-approval-user', userId]);
}

export const navigationUrlForAggregators = ()  => {
  return ( ['/s', 'aggregators']);
}

export const navigationUrlForAggregatorDetails = (aggregatorId: number)  => {
  return ( ['/s', 'aggregator', aggregatorId]);
}

export const navigationUrlForCompanies= ()  => {
  return ( ['/s', 'companies']);
}

export const navigationUrlForCompanyDetail = (originatorBusinessId: number)  => {
  return ( ['/s', 'company', originatorBusinessId]);
}

export const navigationUrlForNotifications = ()  => {
  return ( ['/s', 'notifications']);
}

export const navigationUrlForRateCards = ()  => {
  return ( ['/s', 'rate-cards']);
}

export const navigationUrlForSetMaintenance = ()  => {
  return ( ['/s', 'set-maintenance']);
}

export const navigationUrlForPayments = ()  => {
  return ( ['/s', 'payments']);
}

export type ApplicationProcessQueueQueryParams = {
  view?: KybQueueView,
  reasons?: KybAttentionReason[],
  search?: string,
  sort?: 'PRIORITY' | 'OLDEST' | 'LATEST',
  page?: number,
}

export const APPLICATION_PROCESS_TABS = ['aml', 'kyb'] as const;
export type ApplicationProcessTab = typeof APPLICATION_PROCESS_TABS[number];

export function navigationUrlForApplicationProcess(tab?: ApplicationProcessTab): string[];
export function navigationUrlForApplicationProcess(
  tab: ApplicationProcessTab,
  router: Router,
  queueState: ApplicationProcessQueueQueryParams,
): UrlTree;
export function navigationUrlForApplicationProcess(
  tab: ApplicationProcessTab = 'aml',
  router?: Router,
  queueState?: ApplicationProcessQueueQueryParams,
): string[] | UrlTree {
  const url = ['/s', 'aml', tab];
  if (!router) {
    return url;
  }
  return router.createUrlTree(url, {
    queryParams: {
      ...queueState,
      reasons: queueState?.reasons?.join(','),
    },
  });
}

export const navigationUrlForCreditManagement = ()  => {
  return ( ['/s', 'credit-management']);
}

export const navigationUrlForCronManagement = ()  => {
  return ( ['/s', 'cron-management']);
}

export const navigationUrlForPendingApprovalTransactions = ()  => {
  return ( ['/s', 'pending-approval-transactions']);
}

export const navigationUrlForOauth = () => {
  return ( ['/s', 'oauth']);
}

export const navigationUrlForUnverifiedUsers = () => {
  return ( ['/s', 'unverified-users']);
}

export const navigationUrlForNewApplication = ()  => {
  return ( ['/s', 'new-application']);
}

export const navigationUrlForProfile = () => {
  return ( ['/s', 'profile']);
}

export const navigationUrlForDashboard = ()  => {
  return ( ['/s', 'dashboard']);
}

export const navigationUrlForOverdraftProduct = ()  => {
  return ( ['/s', 'overdraft-product']);
}

export const navigationUrlForPismoAccounts = ()  => {
  return ( ['/s', 'pismo-accounts']);
}

export const navigationUrlForPismoAccount = (pismoAccountNumber: number)  => {
  return ( ['/s', 'pismo-account', pismoAccountNumber]);
}

export const navigationUrlForFAQ = ()  => {
  return ( ['/s', 'faq']);
}

export const navigationUrlForBankStatementsAnalysis = ()  => {
  return ( ['/s', 'bank-statements-analysis']);
}

export const navigationUrlForBankStatementsStatus = ()  => {
  return ( ['/s', 'bank-statements-status']);
}

export const navigationUrlForApplicationErrorPage = (applicationId: number,queryParams?: { [key: string]: string | string[] | undefined }): string[]  => {
  return ( ['/s', 'application-error', String(applicationId)]);
}

export const navigationUrlForOpsErrorPage = (errorCode: 'e-not-operator') => {
  return ( ['/op', 'error', errorCode]);
}

export const navigationUrlForMaintenance = ()  => {
  return ( ['/m', 'maintenance']);
}

export const navigationUrlForLogin = ()  => {
  return ( [`/m`, 'login']);
}

export const navigationUrlForSignup = ()  => {
  //m return router.createUrlTree( ['/m', 'signup']);
  return ( ['/m', 'signup']);
}

export const navigationUrlForForgotPassword = ()  => {
  return ( ['/m', 'forgot-password']);
}

export const navigationUrlForResetPassword = ()  => {
  return ( ['/m', 'reset-password']);
}

export const navigationUrlForAccreditation = ()  => {
  return ( ['/m', 'accreditation']);
}

export const navigationUrlForAccreditationReport = (accreditationId: string, webServiceId: string)  => {
  return ( ['/s', 'accreditation', accreditationId, webServiceId]);
}

export const navigationUrlFor2FA = ()  => {
  return ( [`/m`, '2fa']);
}

export const navigationUrlForReset2FA = ()  => {
  return ( [`/m`, 'reset-2fa']);
}

export const navigationUrlForReset2FAQrCode = ()  => {
  return ( [`/m`,'reset-2fa-qr-code']);
}
export const navigationUrlForReset2FASmsVerification = ()  => {
  return ( [`/m`,'reset-2fa-sms-verification']);
}

export const navigationUrlForBsaSettings = ()  => {
  return (['/s', 'bsa-settings']);
}

export const navigationUrlForDocumentWorklist = ()  => {
  return ( ['/s', 'document-worklist']);
}

export const navigationUrlForCreditWorklist = ()  => {
  return ( ['/s', 'credit-worklist']);
}

export const navigationUrlForClientServicesWorklist = ()  => {
  return ( ['/s', 'client-services-worklist']);
}

export const navigationUrlForSettlementsWorklist = ()  => {
  return ( ['/s', 'settlements-worklist']);
}

export const navigationUrlForRedbook = ()  => {
  return ( ['/s', 'redbook']);
}

export const navigationUrlForBusinessAndOverdraftBorrowingEstimator = () => {
  return (['/s', 'business-and-overdraft-borrowing-estimator']);
}

export const navigationUrlForReporting = ()  => {
  return ( ['/s', 'reporting']);
}

export const navigationUrlForConsentDashboard = ()  => {
  return ( ['/s', 'consent-dashboard']);
}

export const navigationUrlForAccreditationListing = () => {
  return ( ['/s', 'accreditation-listing']);
}

export const navigationUrlForAccreditationTabbing = (accreditationId: string, innerTabs: string, innerTabParam: string)   => {
  return ( innerTabParam ? ['/s', 'accreditation', accreditationId, innerTabs, innerTabParam] : ['/s', 'accreditation', accreditationId, innerTabs]);
}

export const navigationUrlForOverdraftCustomerDashboard = () => {
  return ( ['/o', 'dashboard']);
}

export const navigationUrlForUnactivatedAccount = ()  => {
  return ( ['/m', 'unactivated']);
}

export const navigationUrlForLockedUser = ()  => {
  return ( ['/m', 'lockeduser']);
}

export const navigationUrlForUnverifiedAccount = ()  => {
  return ( ['/m', 'unverified']);
}

export const navigationUrlForPortalRoot = ()  => {
  return ( ['/']);
}

export const navigationUrlForCardOperatorDashboard = ()  => {
  return ( ['/op', 'dashboard']);
}

export const navigationUrlForWhitelabelSettings = () => {
  return (['/s', 'whitelabel-settings']);
}

export const navigationUrlForAddWhitelabelSettingDetails = () => {
  return (['/s', 'whitelabel-settings-details']);
}

export const navigationUrlForEditWhitelabelSettingDetails = (whitelabelId: number) => {
  return (['/s', 'whitelabel-settings-details', whitelabelId]);
}

export const navigationUrlForSystemConnections = () => {
  return ['/s', 'system-connections'];
}

export const navigationUrlForDynabotKnowledge = () => {
  return ['/s', 'dynabot-knowledge'];
}